import React from 'react'
import PropTypes from 'prop-types'
import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import Dialog from 'components/dialog'

const useStyles = makeStyles(theme => ({
  titleRoot: {
    padding: theme.spacing(3, 7, 0.5, 3),
  },
  content: {
    padding: theme.spacing(0, 3, 2),
  },
  bodyText: {
    margin: 0,
    fontSize: '0.875rem',
    lineHeight: 1.5,
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3, 3),
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
  },
}))

const DownloadPlanDialog = ({
  open,
  onClose,
  title,
  description,
  onDownload,
}) => {
  const classes = useStyles()

  const handleDownload = () => {
    onDownload()
    onClose()
  }

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      showCloseButton
      fullWidth
      maxWidth="xs"
    >
      {() => (
        <>
          <DialogTitle classes={{ root: classes.titleRoot }}>
            {title}
          </DialogTitle>
          <DialogContent classes={{ root: classes.content }}>
            <Typography className={classes.bodyText}>{description}</Typography>
          </DialogContent>
          <DialogActions className={classes.actions}>
            <Button color="primary" size="large" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="large"
              disableElevation
              startIcon={<FileDownloadOutlinedIcon fontSize="small" />}
              onClick={handleDownload}
            >
              Download
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DownloadPlanDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onDownload: PropTypes.func.isRequired,
}

export default DownloadPlanDialog
